import React from 'react'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../../../../../components/ui/common/collapsible';
import { ChevronDown } from 'lucide-react';
import { Badge } from '../../../../../components/ui/common/badge';
import { cn } from '../../../../../lib/utils';

interface SubsectionProps {
  title: string;
  icon: React.ComponentType<{ className?: string }>;
  count: number;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

const Subsection: React.FC<SubsectionProps> = ({ title, icon: Icon, count, children, defaultOpen = true }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
   <Collapsible open={open} onOpenChange={setOpen}>
      <div className="tw-border tw-rounded-lg tw-bg-card">
        <CollapsibleTrigger className="tw-flex tw-items-center tw-gap-2 tw-w-full tw-text-left tw-px-4 tw-py-2.5">
          <ChevronDown className={cn('tw-h-4 tw-w-4 tw-text-muted-foreground tw-transition-transform', !open && '-tw-rotate-90')} />
          <Icon className="tw-h-4 tw-w-4 tw-text-primary" />
          <span className="tw-text-sm tw-font-medium">{title}</span>
          <Badge variant="secondary" className="tw-text-xs tw-ml-1">{count}</Badge>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <div className="tw-border-t tw-p-3">{children}</div>
        </CollapsibleContent>
      </div>
    </Collapsible>
  )
}

export default Subsection